

export const codeOptions = [
    { name: 'html', imageName: 'html', cValue: 'html', extension: '.html' },
    { name: 'css', imageName: 'css', cValue: 'css', extension: '.css' },
    { name: 'scss', imageName: 'sass', cValue: 'scss', extension: '.scss' },

    { name: 'javascript', imageName: 'javascript', cValue: 'javascript', extension: '.js' },
    { name: 'typescript', imageName: 'typescript', cValue: 'typescript', extension: '.ts' },
    { name: 'jsx', imageName: 'jsx', cValue: 'jsx', extension: '.jsx' },
    { name: 'tsx', imageName: 'tsx', cValue: 'tsx', extension: '.tsx' },

    { name: 'python', imageName: 'python', cValue: 'python', extension: '.py' },
    { name: 'java', imageName: 'java', cValue: 'java', extension: '.java' },
    { name: 'kotlin', imageName: 'kotlin', cValue: 'kotlin', extension: '.kt' },

    { name: 'c', imageName: 'c', cValue: 'c', extension: '.c' },
    { name: 'cpp', imageName: 'cpp', cValue: 'cpp', extension: '.cpp' },
    { name: 'csharp', imageName: 'csharp', cValue: 'csharp', extension: '.cs' },

    { name: 'xml', imageName: 'xml', cValue: 'xml', extension: '.xml' },
    { name: 'xaml', imageName: 'xaml', cValue: 'xaml', extension: '.xaml' },


    { name: 'go', imageName: 'go', cValue: 'go', extension: '.go' },
    { name: 'php', imageName: 'php', cValue: 'php', extension: '.php' },
    { name: 'ruby', imageName: 'ruby', cValue: 'ruby', extension: '.rb' },
    { name: 'rust', imageName: 'rust', cValue: 'rust', extension: '.rs' },
    { name: 'swift', imageName: 'swift', cValue: 'swift', extension: '.swift' },
    { name: 'lua', imageName: 'lua', cValue: 'lua', extension: '.lua' },
    { name: 'dart', imageName: 'dart', cValue: 'dart', extension: '.dart' },
    { name: 'sql', imageName: 'sql', cValue: 'sql', extension: '.sql' },
    { name: 'less', imageName: 'less', cValue: 'less', extension: '.less' },

    { name: 'arduino', imageName: 'arduino', cValue: 'arduino', extension: '.ino' },
    { name: 'csv', imageName: 'csv', cValue: 'csv', extension: '.csv' },

    { name: 'html', imageName: 'html', cValue: 'html', extension: '.htm' },
    { name: 'sass', imageName: 'sass', cValue: 'scss', extension: '.sass' },

    { name: 'cpp', imageName: 'cpp', cValue: 'cpp', extension: '.cc' },
    { name: 'cpp', imageName: 'cpp', cValue: 'cpp', extension: '.cxx' },
    { name: 'hpp', imageName: 'cpp', cValue: 'cpp', extension: '.hpp' },

    { name: 'json', imageName: 'json', cValue: 'json', extension: '.json' },
] as const;

export const ACCEPTED_SNIPPET_EXTENSIONS = codeOptions.map(c => c.extension);

export const codeSuggestions = [
    { name: 'html', imageName: 'html', cValue: 'html', extension: '.html' },
    { name: 'css', imageName: 'css', cValue: 'css', extension: '.css' },
    { name: 'scss', imageName: 'sass', cValue: 'scss', extension: '.scss' },

    { name: 'javascript', imageName: 'javascript', cValue: 'javascript', extension: '.js' },
    { name: 'typescript', imageName: 'typescript', cValue: 'typescript', extension: '.ts' },
    { name: 'jsx', imageName: 'jsx', cValue: 'jsx', extension: '.jsx' },
    { name: 'tsx', imageName: 'tsx', cValue: 'tsx', extension: '.tsx' },

    { name: 'python', imageName: 'python', cValue: 'python', extension: '.py' },
    { name: 'java', imageName: 'java', cValue: 'java', extension: '.java' },
    { name: 'kotlin', imageName: 'kotlin', cValue: 'kotlin', extension: '.kt' },

    { name: 'c', imageName: 'c', cValue: 'c', extension: '.c' },
    { name: 'cpp', imageName: 'cpp', cValue: 'cpp', extension: '.cpp' },
    { name: 'csharp', imageName: 'csharp', cValue: 'csharp', extension: '.cs' },

    { name: 'xml', imageName: 'xml', cValue: 'xml', extension: '.xml' },
    { name: 'xaml', imageName: 'xaml', cValue: 'xaml', extension: '.xaml' },


    { name: 'go', imageName: 'go', cValue: 'go', extension: '.go' },
    { name: 'php', imageName: 'php', cValue: 'php', extension: '.php' },
    { name: 'ruby', imageName: 'ruby', cValue: 'ruby', extension: '.rb' },
    { name: 'rust', imageName: 'rust', cValue: 'rust', extension: '.rs' },
    { name: 'swift', imageName: 'swift', cValue: 'swift', extension: '.swift' },
    { name: 'lua', imageName: 'lua', cValue: 'lua', extension: '.lua' },
    { name: 'dart', imageName: 'dart', cValue: 'dart', extension: '.dart' },
    { name: 'sql', imageName: 'sql', cValue: 'sql', extension: '.sql' },

    { name: 'arduino', imageName: 'arduino', cValue: 'arduino', extension: '.ino' },
    { name: 'csv', imageName: 'csv', cValue: 'csv', extension: '.csv' },

    { name: 'json', imageName: 'json', cValue: 'json', extension: '.json' },
] as const;

export const SNIPPET_INPUT_ACCEPT = ACCEPTED_SNIPPET_EXTENSIONS.join(",");

export type ResolvedSnippetName =
    | {
        ok: true;
        baseName: string;
        ext: string;
        snippetType: "code" | "text";
        snippetLanguage: string | null;
    }
    | {
        ok: false;
        reason: "empty" | "format" | "language";
    };

// Shared "typed name -> snippet fields" resolution, used by both the New File
// popup (NewSnipPop) and inline file creation in the editor sidebar (FilesTab),
// so the name.extension validation + extension-to-language mapping only lives
// in one place. `manualFileType` is the extension picked via a type-icon tab,
// used when the typed name doesn't include one (only NewSnipPop offers that UI).
export function resolveSnippetFromTypedName(
    typedName: string,
    manualFileType?: string
): ResolvedSnippetName {
    const trimmed = typedName.trim();
    if (!trimmed) return { ok: false, reason: "empty" };

    const lastDot = trimmed.lastIndexOf(".");

    let baseName = "";
    let ext = "";

    if (lastDot > 0) {
        baseName = trimmed.slice(0, lastDot).trim();
        ext = trimmed.slice(lastDot).toLowerCase().trim();
    } else if (manualFileType) {
        baseName = trimmed;
        ext = manualFileType;
    } else {
        return { ok: false, reason: "format" };
    }

    if (!baseName) return { ok: false, reason: "format" };

    const isValidLang = (ACCEPTED_SNIPPET_EXTENSIONS as readonly string[]).includes(ext) || ext === ".txt";
    if (!isValidLang) return { ok: false, reason: "language" };

    const isCode = codeOptions.some((c) => c.extension === ext);
    const snippetLanguage = codeOptions.find((c) => c.extension === ext)?.name ?? null;

    return {
        ok: true,
        baseName,
        ext,
        snippetType: isCode ? "code" : "text",
        snippetLanguage: isCode ? snippetLanguage : null,
    };
}